<template>
  <van-button class="sendverification" native-type="button" :disabled="isSend" @click.stop="ckvcode('domform')" size="small">{{text}}</van-button>
</template>
<script>
import { GetVerificationCode } from '@/api/user'
export default {
  name: 'PosterLand',
  components: {},
  mixins: [],
  props: {
    username: {
      type: String,
      default: ''
    },
    num: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      isSend: false,                //发送验证码
      nums: this.num,
      text: '发送验证码',
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
  },
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
  methods: {
    async ckvcode(){
      if(/^(?:(?:\+|00)86)?1\d{10}$/.test(this.username)){
        await GetVerificationCode({ mobilePhone: this.username })
        this.isSend = true
        let setl = setInterval(()=>{
          this.nums--
          this.text = `倒计时${this.nums}s`
          if(this.nums === 0){
            clearInterval(setl)
            this.nums = this.num
            this.text = `发送验证码`
            this.isSend = false
          }
        },1000)
      }
    },
    onSubmit(values) {
      console.log('submit', values);
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
  }
}
</script>
